"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = randomId;

var _mathRandom = _interopRequireDefault(require("math-random"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-magic-numbers: ["error", { "ignore": [2, 5, 36] }] */
function randomId() {
  var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  return (0, _mathRandom.default)().toString(36).substr(2, maxLength);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyYW5kb21JZCIsIm1heExlbmd0aCIsInJhbmRvbSIsInRvU3RyaW5nIiwic3Vic3RyIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvcmFuZG9tSWQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiLyogZXNsaW50IG5vLW1hZ2ljLW51bWJlcnM6IFtcImVycm9yXCIsIHsgXCJpZ25vcmVcIjogWzIsIDUsIDM2XSB9XSAqL1xuXG5pbXBvcnQgcmFuZG9tIGZyb20gJ21hdGgtcmFuZG9tJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gcmFuZG9tSWQobWF4TGVuZ3RoID0gNSk6IHN0cmluZyB7XG4gIHJldHVybiByYW5kb20oKS50b1N0cmluZygzNikuc3Vic3RyKDIsIG1heExlbmd0aCk7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFFQTs7OztBQUZBO0FBSWUsU0FBU0EsUUFBVCxHQUF5QztFQUFBLElBQXZCQyxTQUF1Qix1RUFBWCxDQUFXO0VBQ3RELE9BQU8sSUFBQUMsbUJBQUEsSUFBU0MsUUFBVCxDQUFrQixFQUFsQixFQUFzQkMsTUFBdEIsQ0FBNkIsQ0FBN0IsRUFBZ0NILFNBQWhDLENBQVA7QUFDRCJ9